export default __webpack_public_path__ + "static/underline-26-mobile-038377af63bd9dc928b763c39837fcb0.svg";